var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgImageFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.666 5.0026H10.8327L9.16602 3.33594H3.33268C2.41602 3.33594 1.66602 4.08594 1.66602 5.0026V15.0026C1.66602 15.9193 2.41602 16.6693 3.33268 16.6693H16.666C17.5827 16.6693 18.3327 15.9193 18.3327 15.0026V6.66927C18.3327 5.7526 17.5827 5.0026 16.666 5.0026ZM16.666 15.0026H3.33268V5.0026H8.49935L10.166 6.66927H16.666V15.0026ZM14.9993 13.3359L11.8327 9.16927H11.666L9.24935 12.3359L7.49935 10.0859L4.99935 13.3359H14.9993ZM8.33268 7.91927C8.33268 7.2526 7.74935 6.66927 7.08268 6.66927C6.41602 6.66927 5.83268 7.2526 5.83268 7.91927C5.83268 8.58594 6.41602 9.16927 7.08268 9.16927C7.74935 9.16927 8.33268 8.58594 8.33268 7.91927Z",
    fill: "#002244"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgImageFolder);
export default __webpack_public_path__ + "static/media/svg_image_folder.993f5011390dadb38c5f035330b1f731.svg";
export { ForwardRef as ReactComponent };